const occupationOptions = [
  { name: "HEALTHCARE & LIFE SCIENCES", shortenedName: "healthcare"},
  { name: "TECHNOLOGY, MEDIA & TELECOM INDUSTRIALS", shortenedName: "tech"},
  { name: "BUSINESS & FINANCIAL SERVICES", shortenedName: "biz"},
  { name: "WHOLESALE & DISTRIBUTION", shortenedName: "distribution"},
  { name: "AUTOMOTIVE", shortenedName: "automotive"},
  { name: "ENERGY", shortenedName: "energy"},
  { name: "FOOD & BEVERAGE", shortenedName: "food-services"},
  { name: "TRANSPORTATION & DISTRIBUTION", shortenedName: "transportation"},
  { name: "ENGINEERING, CONTRACTING & CONSTRUCTION", shortenedName: "engineering"},
  { name: "MANUFACTURING & FABRICATION", shortenedName: "manufacturing"},
  { name: "RETAIL", shortenedName: "retail"},
];

export { occupationOptions }
